import React, {useEffect, useState} from 'react';
import image from "../../../resources/img/hallFame/genph5.jpg";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {changeRegisterStatus, loginUser} from "../../../reduxLib/userLib";

const initialState = {
    "username":"",
    "password":""
}

function HomeAdmin() {

    let navigate = useNavigate();
    let dispatch = useDispatch();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showPass, setShowPass] = useState(false);

    let status = useSelector((state)=> state.userreducer.loginstatus);
    const [user, setuser] = useState(initialState);

    useEffect(()=>{
        dispatch(changeRegisterStatus())
        if(status === 'success'){
            //console.log('1',status)
            navigate("/admin/home");
        }
        else if(status === 'failure'){
            //console.log('2',status)
            setError('Invalid Credentials')
        }

    },[status])



    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            console.log('User :', user);
            dispatch(loginUser(user));
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };
    return (

        <main className="bg-cream min-h-screen font-print">
            <section id="login-section" className="py-20 min-h-[calc(100vh-200px)] flex items-center justify-center">
                <div className="max-w-6xl mx-auto px-6 w-full">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

                        <div id="login-image" className="hidden lg:block">
                            <div className="relative h-[600px] rounded-2xl overflow-hidden shadow-2xl">
                                <img className="w-full h-full object-cover"
                                     src={image}
                                     alt="handmade wicker baskets arranged beautifully in workshop, natural lighting, artisan tools, warm atmosphere"/>
                                <div
                                    className="absolute inset-0 bg-gradient-to-t from-custom-green/80 to-transparent flex items-end p-12">
                                    <div className="text-white">
                                        <h2 className="text-4xl font-serif font-bold mb-4">Admin Portal</h2>
                                        <p className="text-lg opacity-90">Manage your handcrafted basket collection with
                                            ease</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div id="login-form-container" className="bg-white rounded-2xl shadow-xl p-12">
                            <div className="mb-8">
                                <div className="flex items-center justify-center mb-6">
                                    <div
                                        className="w-16 h-16 bg-custom-green rounded-full flex items-center justify-center">
                                        <i className="fas fa-user-shield text-white text-2xl"></i>
                                    </div>
                                </div>
                                <h1 className="text-3xl font-serif font-bold text-gray-800 text-center mb-2">Welcome
                                    Back</h1>
                                <p className="text-gray-600 text-center">Sign in to access the admin dashboard</p>

                                {error && (
                                    <p className="text-red-600 text-center text-sm mt-4">{error}</p>
                                )}
                            </div>

                            <form id="admin-login-form" onSubmit={handleSubmit} className="space-y-6">
                                <div id="email-field">
                                    <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-2">Username</label>
                                    <div className="relative">
                                        <input type="username" id="username" name="username" placeholder="admin@rotheras.gr" value={user.username}
                                               onChange={(event)=>setuser({...user, [event.target.name]:event.target.value})}
                                               className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-custom-green focus:ring-2 focus:ring-custom-green/20 transition-all duration-300"
                                               required/>
                                        <i className="fas fa-envelope absolute left-4 top-4 text-gray-400"></i>
                                    </div>
                                </div>

                                <div id="password-field">
                                    <label htmlFor="password"
                                           className="block text-sm font-medium text-gray-700 mb-2">Password</label>
                                    <div className="relative">
                                        <input id="password" name="password"
                                               type={showPass ? "text" : "password"}
                                               value={user.password}
                                               onChange={(event)=>setuser({...user, [event.target.name]:event.target.value})}
                                               placeholder="Enter your password"
                                               className="w-full pl-12 pr-12 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-custom-green focus:ring-2 focus:ring-custom-green/20 transition-all duration-300"
                                               required/>
                                        <i className="fas fa-lock absolute left-4 top-4 text-gray-400"></i>
                                        <button
                                            type="button"
                                            onClick={() => setShowPass(s => !s)}
                                            className="absolute right-4 top-4 text-gray-400 hover:text-custom-green transition-colors"
                                            aria-label={showPass ? "Hide password" : "Show password"}
                                        >
                                            <i className={`fas ${showPass ? "fa-eye-slash" : "fa-eye"}`}></i>
                                        </button>
                                    </div>
                                </div>


                                <button type="submit" disabled={loading}
                                        className="w-full bg-custom-green text-white py-3 rounded-lg font-medium hover:bg-dark-green transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5">
                                    {loading ? "Signing in..." : "Sign In"}
                                </button>


                            </form>

                        </div>

                    </div>
                </div>
            </section>
        </main>
    );

}

export default HomeAdmin;